"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOCIAL_DESIGN_VERSION = void 0;
/**
 * Social/og:image design version. Bump when the composition changes: it is part
 * of both the derived S3 key and the public URL, so cached images (crawlers,
 * browsers, social networks) are invalidated.
 */
exports.SOCIAL_DESIGN_VERSION = 2;
